import { userService } from '../_services';
import { router } from '../router/router'

const user = JSON.parse(localStorage.getItem('user'));
const state = user
    ? { status: { loggedIn: true }, user }
    : { status: {}, user: null };

const actions = {
    login({ dispatch, commit }, { username, password }) {
        console.log('account.module.login');

        commit('loginRequest', { username });

        userService.login(username, password)
            .then(
                user => {
                    commit('loginSuccess', user);
                    router.push('/');
                },
                error => {
                    commit('loginFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    logout({ commit }) {
        //console.log('account.module.logout');
        userService.logout();
        commit('logout');
    },
    register({ dispatch, commit }, user) {
        //console.log('account.module.register');
        commit('registerRequest', user);

        userService.register(user)
            .then(
                user => {
                    //console.log('account.module.register success');
                    commit('registerSuccess', user);
                    router.push('/users');
                    setTimeout(() => {
                        // display success message after route change completes
                        dispatch('alert/success', 'Registration successful', { root: true });
                    })
                },
                error => {
                    //console.log('account.module.register failure');
                    commit('registerFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    }
};

const mutations = {
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user = user;

        //console.log('mutations.loginRequest state:' + JSON.stringify(state))
    },
    loginSuccess(state, user) {
        state.status = { loggedIn: true };
        state.user = user;

        //console.log('mutations.loginSuccess state:' + JSON.stringify(state))
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;

        //console.log('mutations.loginFailure state:' + JSON.stringify(state))
    },
    logout(state) {
        state.status = {};
        state.user = null;

        //console.log('mutations.logout state:' + JSON.stringify(state))
    },
    registerRequest(state, user) {
        state.status = { registering: true };

        //console.log('mutations.registerRequest state:' + JSON.stringify(state))

    },
    registerSuccess(state, user) {
        state.status = {};

        //console.log('mutations.registerSuccess state:' + JSON.stringify(state))
    },
    registerFailure(state, error) {
        state.status = {};
        //console.log('mutations.registerFailure state:' + JSON.stringify(state))
    }
};

export const account = {
    namespaced: true,
    state,
    actions,
    mutations
};